
export const getTextColor = (label: string, value: string): string => {
    const lower = value.toLowerCase();

    //If it’s literally "unknown", always gray:
    if (lower === "unknown") {
      return "font-medium text-semantic-text-secondary";
    }
    /*
     * Contract and configuration rows, whose vocabulary this helper owns.
     *
     * Status rows are deliberately absent. They used to be here, matched by an
     * exact label string, which made the colour of a service's status depend on
     * its spelling: Cloud Connectivity emitted "Service status" in lower case,
     * missed this list, and rendered with no colour at all. Worse, a label that
     * did match but carried a value this function does not recognise fell
     * through to the danger branch below — so "No data", the honest answer when
     * telemetry cannot be read, painted red. Both are assertions from the
     * absence of evidence, which is the defect CTX-547 already paid for once.
     *
     * Status now travels as a `statusVariant` on the item, decided by
     * `resolveServiceStatusTag` — the same call the four service lists make —
     * and the cards paint it with a `GenericTag`. Do not add a status label
     * back here; add it to that helper, and let the surfaces import it.
     *
     * "Logical Status" went with them: no mapper emits it.
     */
    const importantFields = ["LAG status", "Subscription Status", "Auto renew"];
    const membersField = "Members";
  
    if (importantFields.includes(label)) {
      if (
        lower === "active" ||
        lower === "up" ||
        lower === "yes" ||
        lower === "available"
      ) {
        return "font-medium text-semantic-text-brand";
      }
      if (lower === "warning") {
        return "font-medium text-yellow-600";
      }
      return "font-medium text-semantic-text-danger";
    }
  
    if (label === membersField) {
      return "font-medium text-semantic-text-brand ";
    }
  
    return "text-semantic-text-secondary";
  };
  